export default __webpack_public_path__ + "static/media/09.7b46cb53.jpg";